/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

import { RefObject, useRef } from "react";

import { useIsXOverflow } from "../../../../shared/hooks/useIsXOverflow";
import { LongTextTooltip } from "../../../Tooltip/LongTextTooltip";
import { useStyles } from "../../styles";

interface IDialogTitleWithTooltipProps {
  title: string;
  tooltipText: string;
}

const DialogTitleWithTooltip = ({
  title,
  tooltipText
}: IDialogTitleWithTooltipProps) => {
  const ref: RefObject<null> | null = useRef(null);
  const isOverflowing = useIsXOverflow(ref);

  const { dialogTitleWithTooltip } = useStyles({});

  return (
    <LongTextTooltip title={tooltipText} open={isOverflowing}>
      <div css={css(dialogTitleWithTooltip)} ref={ref}>
        {title}
      </div>
    </LongTextTooltip>
  );
};

export default DialogTitleWithTooltip;
